import { cloneDeep } from 'lodash'
import { TemplateElement } from '../templateEditor.types'
import { nextElementId } from './nextElementId'

const PASTE_OFFSET = 20

const prefixFor = (type: TemplateElement['type']) => {
    switch (type) {
        case 'text':
            return 'txt'
        case 'shape':
            return 'sh'
        case 'list':
            return 'lst'
        case 'table':
            return 'tbl'
        case 'image':
            return 'img'
        case 'video':
            return 'vid'
        case 'group':
            return 'grp'
        default:
            return 'el'
    }
}

export const cloneElement = (element: TemplateElement, offset = PASTE_OFFSET): TemplateElement => {
    const cloned = cloneDeep(element)
    cloned.id = nextElementId(prefixFor(element.type))
    cloned.x += offset
    cloned.y += offset
    cloned.groupId = null
    if (cloned.type === 'group') {
        cloned.children = []
    }
    return cloned
}
